import type { TRuleWithTheme } from '@/styles/theme';

export const link: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});

export const label: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
});

export const anchor: TRuleWithTheme = () => ({
    transform: 'rotate(-90deg)',
});

// A button, not a link, so it must be talked out of every default a button carries: the user agent's
// font and colour, its border and background, and its shrink-to-fit width.
export const button: TRuleWithTheme = () => ({
    display: 'block',
    width: '100%',
    padding: 0,
    border: 'none',
    background: 'none',
    color: 'inherit',
    fontFamily: 'inherit',
    cursor: 'pointer',
});
